define.alias("checkout/components/seamless-checkout/non-admin-modal", "calendar/components/seamless-checkout/non-admin-modal");